/**
 * Application roles mapped from AAD groups
 * Values must match exactly with backend RoleMapping.Roles
 */
export enum Role {
  Admin = 'Admin',
  EnterpriseLead = 'Enterprise Lead',
  OperationsManager = 'Operations Manager',
  AMORETeam = 'AMORE Team',
  ProjectLead = 'Project Lead',
  PlatformUser = 'Platform User',
  // TechnicalOwner = 'Technical Owner',
  // BusinessOwner = 'Business Owner',
  // InformationSteward = 'Information Steward'
}
